import { Injectable, EventEmitter } from '@angular/core';
import { Gallery } from 'src/app/_models';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GallaryService {
  private url: string = environment.apiUrl;
  gallery: Gallery[] = [];
  notifer = new EventEmitter();
  constructor(private http: HttpClient, private toastr: ToastrService) {}

  GetAllGallery(pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}Gallery/GetAllGallery/${pageSize}/${pageIndex}`);
  }
  GetGalleryById(id: number) {
    return this.http.get(`${this.url}Gallery/GetGallery/${id}`);
  }
  GetAlbumFilesByGalleryId(galleryId: number) {
    return this.http.get(`${this.url}Gallery/GetAlbumFiles/${galleryId}`);
  }
  UploadPhoto(data: FormData) {
    return this.http.post(`${this.url}Gallery/UploadPhoto`, data);
  }
  RemovePhoto(id: number) {
    return this.http.delete(`${this.url}Gallery/RemovePhoto/${id}`);
  }
  CreateAlbum(data) {
    return this.http.post(`${this.url}Gallery/CreateAlbum`, data);
  }
  UpdateAlbum(data) {
    return this.http.put(`${this.url}Gallery/UpdateAlbum`, data);
  }
  // /api/Gallery/DeleteAlbum/{id}
  DeleteAlbum(id: number) {
    return this.http.delete(`${this.url}Gallery/DeleteAlbum/${id}`);
  }
  save(gallery: Gallery): void {
    this.gallery.push(gallery);
    this.toastr.success('Gallery Successfully Saved');
  }
  update(gallery: Gallery): void {
    const index = this.gallery.findIndex(item => item.galleryId === gallery.galleryId);
    this.gallery[index].galleryType = gallery.galleryType;
    this.gallery[index].galleryTypeName = gallery.galleryTypeName;
    this.gallery[index].imagesList = gallery.imagesList;
    this.gallery[index].imagesNumber = gallery.imagesNumber;
    this.gallery[index].name = gallery.name;
    this.gallery[index].publishDate = gallery.publishDate;
    this.gallery[index].usersList = gallery.usersList;
    this.gallery[index].visibleTo = gallery.visibleTo;
    this.toastr.success('Gallery Successfully Updated');
  }
  getGalleryLength(): number {
    return this.gallery.length;
  }
  getAllGalleries(): Gallery[] {
    return this.gallery;
  }
  getGalleryById(id: number): Gallery {
    const gallery = this.gallery.find(item => item.galleryId === id);
    return gallery ? gallery : null;
  }
  remove(item: Gallery) {
    const i = this.gallery.findIndex(f => f.galleryId === item.galleryId);
    if (i !== -1) {
      this.gallery.splice(i, 1);
      this.notifer.emit(this.gallery);
    }
  }
}
